import React, { useState } from 'react';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Subtitle } from 'src/pages/scheduleSurgery/components/surgery/notifications/Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { useTranslation } from 'react-i18next';

const NotImplantingAllUNiDRods = ({ onClose }) => {
    const { t } = useTranslation();

    let ReasonsForNotImplanting = [
        {
            title: t('procedure.unid.ManufacturingIssue'),
            description: t(
                'procedure.unid.ReasonsForNotImplanting.ManufacturingIssueDescription'
            ),
            complaint: t('procedure.unid.ReasonsForNotImplanting.complaint'),
            expandedCard: false,
        },
        {
            title: t('procedure.unid.IssuewithLengthorContour'),
            description: t(
                'procedure.unid.ReasonsForNotImplanting.IssuewithLengthorContourDescription'
            ),
            complaint: t('procedure.unid.ReasonsForNotImplanting.complaint'),
            expandedCard: false,
        },
        {
            title: t('procedure.unid.SalesOperations'),
            description: t(
                'procedure.unid.ReasonsForNotImplanting.SalesOperationsDescription'
            ),
            complaint: t('procedure.unid.ReasonsForNotImplanting.complaint'),
            expandedCard: false,
        },
        {
            title: t('procedure.unid.MultipleVersionsOrdered'),
            description: t(
                'procedure.unid.ReasonsForNotImplanting.MultipleVersionsOrderedDecrption'
            ),
            complaint: t('procedure.unid.ReasonsForNotImplanting.complaint'),
            expandedCard: false,
        },

        {
            title: t('procedure.unid.NotDeliveredonTime'),
            description: t(
                'procedure.unid.ReasonsForNotImplanting.NotDeliveredonTimeDescription'
            ),
            complaint: t('procedure.unid.ReasonsForNotImplanting.complaint'),
            expandedCard: false,
        },
        {
            title: t('procedure.unid.SurgeonChangedSurgicalPlan'),
            description: t(
                'procedure.unid.ReasonsForNotImplanting.SurgeonChangedSurgicalPlanDescription'
            ),
            complaint: t('procedure.unid.ReasonsForNotImplanting.complaint'),
            expandedCard: false,
        },
    ];

    const [initialData, setInitialData] = useState(ReasonsForNotImplanting);
    const toggleCard = (title) => {
        let newArray = [...initialData];
        newArray.map((data) => {
            if (data.title == title) data.expandedCard = !data.expandedCard;
        });
        setInitialData(newArray);
    };

    return (
        <>
            <Popup
                title={t('reportUsage.procedure.unidSurgery.SurgeryOrReport.Reasons')}
                onClose={onClose}
                margin
                popupContentPadding={'15px 20px 30px 20px'}
                addProductSpecific={'unset'}
                iconWidth={'25px'}
                borderRadius={'6px'}
                id={'reportUsage-notImplantingAllUNiDRods-popup'}
            >
                <MyProfileDiv>
                    {initialData.map((data, index) => {
                        return (
                            <CollapsableCard
                                id={'reportUsage-notImplantingAllUnidRods-procedure-title'}
                                key={index}
                                title={data.title}
                                onClick={() => toggleCard(data.title)}
                                isExpanded={data.expandedCard}
                                titleFontSize={'14px'}
                                currentActivity={true}
                                margin={'0'}
                                padding={'10px 2px 10px 0px'}
                                borderRadius={'none'}
                                boxShadow={'0px 0px 2px #00000029'}
                                color={'#202124'}
                            >
                                {data.expandedCard ? (
                                    <>
                                        <Subtitle>{data.description}</Subtitle>
                                        {(data.title ==
                                            t(
                                                'procedure.unid.ManufacturingIssue'
                                            ) ||
                                            data.title ==
                                                t(
                                                    'procedure.unid.IssuewithLengthorContour'
                                                )) && (
                                            <Subtitle>
                                                <StyledSpan>
                                                    {t('reportUsage.procedure.unidSurgery.SurgeryOrReport.Complaint')}{' '}
                                                </StyledSpan>
                                                {`${data.complaint} `}
                                            </Subtitle>
                                        )}
                                    </>
                                ) : null}
                            </CollapsableCard>
                        );
                    })}
                </MyProfileDiv>
            </Popup>
        </>
    );
};

export default NotImplantingAllUNiDRods;

export const MyProfileDiv = styled.div`
    width: 430px;
    height: 450px;
    overflow-y: scroll;
    ${media.mobileDevice`
         width: 100%;
         max-height: 315px;               
         `}
`;

export const StyledSpan = styled.span`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-top: 10px;
`;
